import useIsNexaDashboard from "../nexa/hooks/useIsNexaDashboard";


const useHideFeedback = () => {

  const isNexaDashbaord = useIsNexaDashboard();
  // add other conditions if needed

  return isNexaDashbaord;
}

export default useHideFeedback;
